const gmtOffSetFunc = () => {
    const date = new Date();
    const offset = -date.getTimezoneOffset();
    const sign = offset >= 0 ? '+' : '-';
    const absOffset = Math.abs(offset);
    const hours = String(Math.floor(absOffset / 60)).padStart(2, '0');
    const minutes = String(absOffset % 60).padStart(2, '0');
    
    // const gmtOffset = `GMT${sign}${hours}:${minutes}`;
    const gmtOffset = `${sign}${hours}:${minutes}`;
    return gmtOffset
}

const formattedGridList = (newGridList) => {
    return newGridList.map(item => {
        const dateObj = new Date(item.date);
        const year = dateObj.getFullYear();
        const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
        const day = dateObj.getDate().toString().padStart(2, '0');
        
        return {
            ...item,
            date: `${year}-${month}-${day}`
        };
    });
};

export const fetchSchedule = async (
    setLoaderStatus, 
    locationState, 
    Schedules_list, 
    setProgramList,
    setOriginalProgramList,
    setFillerist,
    setPromoList,
    Schedules_Datalist,
    Schedules_Datalist_Ist,
    setGridList,
    startDateUTC,
    endDateUTC,
    setDate,
    setWeeklyView,
    setWeeklyViewLoopData
) => {
    setLoaderStatus(true);
    if(!locationState?.state?.channelId) {
        return;
    }

    if (locationState.state.gridList) {
        setWeeklyView(locationState.state.weeklyView)
        let loopGridList = locationState.state.gridList;

        const currentEpoch = Date.now();

        const playingIndex = loopGridList.findIndex(item => item.isPlaying);
        // Initialize a new array to hold updated objects
        let updatedGridList = [...loopGridList];

        if (playingIndex === -1) {
            let startAt = currentEpoch;
            for (let i = 0; i < updatedGridList.length; i++) {
                const endAt = startAt + updatedGridList[i].totalDurationInMillis;
                const totalDuration = updatedGridList[i].totalDurationInMillis;
                updatedGridList[i] = {
                    ...updatedGridList[i],
                    startAt,
                    endAt,
                    totalDuration,
                };
                startAt = endAt; // Prepare for next item
            }
            
            const todayDate = new Date();
            todayDate.setHours(0, 0, 0, 0);
            const futureDate = new Date(todayDate);
            futureDate.setDate(futureDate.getDate() + 7);
            const epochTime = futureDate.getTime();

            let index = 0;
            const originalList = [...updatedGridList];
            while (true) {
                const item = originalList[index];
                const totalDuration = item.totalDurationInMillis;
                const endAt = startAt + totalDuration;

                if (startAt >= epochTime) {
                    break;
                }

                updatedGridList.push({
                    ...item,
                    startAt,
                    endAt,
                    totalDuration,
                });

                startAt = endAt;
                index = (index + 1) % originalList.length;
            }
            
        } else {
            // Step 1: Calculate startAt & endAt for playing item
            const playingItem = loopGridList[playingIndex];
            const playingStartAt = currentEpoch - playingItem.runTime;
            const playingEndAt = playingStartAt + playingItem.totalDurationInMillis;

            // Update playing item
            updatedGridList[playingIndex] = {
                ...playingItem,
                startAt: playingStartAt,
                endAt: playingEndAt,
            };

            // Step 2: Calculate for objects after playingIndex (forward)
            for (let i = playingIndex + 1; i < updatedGridList.length; i++) {
                const prev = updatedGridList[i - 1];
                const current = updatedGridList[i];
                const startAt = prev.endAt;
                const endAt = startAt + current.totalDurationInMillis;
                const totalDuration = current.totalDurationInMillis;
                updatedGridList[i] = {
                ...current,
                startAt,
                endAt,
                totalDuration,
                };
            }

            // Step 3: Calculate for objects before playingIndex (backward)
            for (let i = playingIndex - 1; i >= 0; i--) {
                const next = updatedGridList[i + 1];
                const current = updatedGridList[i];
                const endAt = next.startAt;
                const startAt = endAt - current.totalDurationInMillis;
                const totalDuration = current.totalDurationInMillis;
                updatedGridList[i] = {
                ...current,
                startAt,
                endAt,
                totalDuration,
                };
            }
            
            let startAt = updatedGridList[updatedGridList.length - 1].endAt;
            const todayDate = new Date();
            todayDate.setHours(0, 0, 0, 0);
            const futureDate = new Date(todayDate);
            futureDate.setDate(futureDate.getDate() + 7);
            const epochTime = futureDate.getTime();

            let index = 0;
            const originalList = [...updatedGridList];

             while (true) {
                const item = originalList[index];
                const totalDuration = item.totalDurationInMillis;
                const endAt = startAt + totalDuration;

                if (startAt >= epochTime) {
                    break;
                }

                updatedGridList.push({
                    ...item,
                    startAt,
                    endAt,
                    totalDuration,
                });

                startAt = endAt;
                index = (index + 1) % originalList.length;
            }
        }

        // Get the earliest date from updatedGridList
        const earliestProgramDate = updatedGridList.length
        ? Math.min(...updatedGridList.map(p => new Date(p.startAt).setHours(0, 0, 0, 0)))
        : new Date(startDateUTC).setHours(0, 0, 0, 0);

        // Ensure earliest date is used for looping
        const startDate = new Date(startDateUTC);
        startDate.setHours(0, 0, 0, 0);
        const effectiveStartDate = new Date(Math.min(startDate.getTime(), earliestProgramDate));

        // Calculate total days between effectiveStartDate and setDate
        const totalDays = setDate + Math.ceil((startDate.getTime() - effectiveStartDate.getTime()) / (1000 * 60 * 60 * 24));

        let emptyUpdatedGridList = [];

        // Build date list starting from effectiveStartDate
        for (let i = 0; i <= totalDays; i++) {
            const currentDate = new Date(effectiveStartDate);
            currentDate.setDate(currentDate.getDate() + i);
            currentDate.setHours(0, 0, 0, 0);
            const epochTimestamp = currentDate.getTime();

            if (!emptyUpdatedGridList.some(entry => entry.date === epochTimestamp)) {
                emptyUpdatedGridList.push({
                    date: epochTimestamp,
                    published: false,
                    scheduleItems: [],
                    isEdit: false
                });
            }
        }

        // Assign programs to their respective date blocks
        const updatedEmptyGridList = emptyUpdatedGridList.map((item, index, arr) => {
            const currentDate = item.date;
            const nextDate = arr[index + 1] ? arr[index + 1].date : Infinity;

            const matchingPrograms = updatedGridList.filter(
                (program) => program.startAt >= currentDate && program.startAt < nextDate
            );

            return {
                ...item,
                scheduleItems: matchingPrograms
            };
        });
        setWeeklyViewLoopData(updatedEmptyGridList);
        
        // Get today's date at 00:00
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        // Get range: 1 day before today to 7 days after
        const startRange = new Date(today);
        startRange.setDate(startRange.getDate() - 1);
        const endRange = new Date(today);
        endRange.setDate(endRange.getDate() + 7);

        // Filter 8-day window
        const filteredGridList = updatedEmptyGridList.filter(item =>
            item.date >= startRange.getTime() && item.date <= endRange.getTime()
        );

        // Set only the filtered dates to view
        setGridList(filteredGridList);
    } else {
        const scheduleData = await Schedules_list(locationState?.state?.channelId, 'PROGRAM');
        setProgramList(scheduleData?.data);
        setOriginalProgramList(scheduleData?.data);
    
        const fillerData = await Schedules_list(locationState?.state?.channelId, 'FILLER');
        setFillerist(fillerData?.data);
    
        const promoData = await Schedules_list(locationState?.state?.channelId, 'PROMO');
        setPromoList(promoData?.data);
    
        let dataPayload = {
            "startDate": startDateUTC,
            "endDate" : endDateUTC,
            "timeOffset": gmtOffSetFunc()
        }
    
        const gridData = await Schedules_Datalist_Ist(locationState?.state?.channelId, dataPayload);
        
        const updatedGridList = gridData?.data?.data?.map((item) => {
            // let sequenceCounter = 1;
            let sequenceCounter = 1; // Initialize sequence counter
            const updatedScheduleItems = item?.scheduleItems?.map((scheduleItem, index) => {
                let totalPrevDuration = 0; // Tracks sum of all previous durations
    
                const updatedAdBreaks = scheduleItem?.adBreaks?.map((adBreak, adIndex) => {
                    const updatedAd = {
                        ...adBreak,
                        adSqId: adIndex + 1, // Add adSqId
                        adInsertionPoint: adBreak.startOffsetInMillis - totalPrevDuration
                    };
                    totalPrevDuration += adBreak.duration; // Update total duration
                    return updatedAd;
                });
    
                return {
                    id: scheduleItem.assetId, // Add id field
                    ...scheduleItem,
                    sequence: sequenceCounter++, // Remove sequence
                    adBreaks: updatedAdBreaks,
                };
            });
            
            return {
                // date: item.date,
                // date: Math.floor(new Date(item.date).getTime()),
                date: new Date(item.date).setHours(0, 0, 0, 0),
                published: item?.published,
                // date: new Date(item.date).getTime(),
                scheduleItems: updatedScheduleItems,
                isEdit: false
            };
        });
        
        // Add empty dates for the range
        for (let i = 0; i <= setDate; i++) {
            const currentDate = new Date(startDateUTC);
            // currentDate.setUTCDate(currentDate.getUTCDate() + i);
            currentDate.setDate(currentDate.getDate() + i);
    
            // Set the time to 12 AM (midnight)
            // currentDate.setUTCHours(0, 0, 0, 0);
            currentDate.setHours(0, 0, 0, 0);
    
            const epochTimestamp = currentDate.getTime();
            // const formattedDate = currentDate.toISOString().slice(0, 10);
            
            // Check if date already exists in updatedGridList
            // if (!updatedGridList?.some((entry) => entry.date === epochTimestamp)) {
            if (!updatedGridList?.some((entry) => Math.floor(new Date(entry.date).getTime()) === epochTimestamp)) {
                updatedGridList?.push({
                    date: epochTimestamp,
                    published: false,
                    // date: new Date(formattedDate).getTime(),
                    scheduleItems: [], // Add empty scheduleItems
                    isEdit: false
                });
            }
        }
        
        // Sort dates to maintain order
        updatedGridList?.sort((a, b) => new Date(a.date) - new Date(b.date));
        setGridList(updatedGridList);
    }
    setLoaderStatus(false);
};

export const update_schedule = async (
    panelDate,
    gridList,
    Schedule_update,
    locationState,
    toast,
    today,
    setLoaderStatus,
    newGridData,
    Schedule_update_weekly,
    startDate,
    fetchLinearData,
) => {
    // let newGridList = gridList.slice(1);
    const currentMidnight = new Date().setHours(0, 0, 0, 0);
    let originalGridList = gridList.slice(1);
    originalGridList = originalGridList.filter(item => item.date >= currentMidnight);
    let newGridList = newGridData.slice(1);

    if (panelDate) {
        const gridListByDate = newGridList.map((item) => ({
            ...item,
            scheduleItems: item.date === panelDate || item.published ? item.scheduleItems : []
        }));
        const formattedGridList = gridListByDate.map(item => {
            const dateObj = new Date(item.date);
            const year = dateObj.getFullYear();
            const month = (dateObj.getMonth() + 1).toString().padStart(2, '0'); // Adding 1 to month as it's 0-indexed
            const day = dateObj.getDate().toString().padStart(2, '0'); // Padding single digit days with zero
            
            return {
                ...item,
                date: `${year}-${month}-${day}` // Format as yyyy-mm-dd
            };
        });
        const response = await Schedule_update(formattedGridList, locationState?.state?.channelId);
        if (response) {
            toast.success("Channel Updated successfully", {
                position: toast.POSITION.BOTTOM_RIGHT,
                autoClose: 3000
            });
            // today();
            const newStartDate = new Date(startDate);
            newStartDate.setDate(newStartDate.getDate());
            const start = newStartDate.toISOString().split("T")[0];

            const newEndDate = new Date(startDate);
            newEndDate.setDate(newEndDate.getDate() + 7);
            const end = newEndDate.toISOString().split("T")[0];
            fetchLinearData(start, end, 7);
            setLoaderStatus(false);
        } else {
            toast.error("Channel Update failed", {
                position: toast.POSITION.BOTTOM_RIGHT,
                autoClose: 3000
            });
            setLoaderStatus(false);
        }
    } else {
        setLoaderStatus(true);
        const datesArray = [];
        const updatedGridList = newGridData.map((item) => {
            // Saare scheduleItems ke totalDuration ka sum nikalna
            const totalDurationInMillis = item.scheduleItems.reduce((acc, schedule) => acc + schedule.totalDuration, 0);
            // 23:55:00 => 86100000 ms
            const isValid = totalDurationInMillis >= 86100000 || item.published;

            if (isValid) {
                datesArray.push(item?.date);
            }
        });

        // const filteredGridList = newGridList.map(item => ({
        //     ...item,
        //     scheduleItems: datesArray.includes(item.date) ? item.scheduleItems : []
        // }));
        
        // const formattedGridList = filteredGridList.map(item => {
        //     const dateObj = new Date(item.date);
        //     const year = dateObj.getFullYear();
        //     const month = (dateObj.getMonth() + 1).toString().padStart(2, '0'); // Adding 1 to month as it's 0-indexed
        //     const day = dateObj.getDate().toString().padStart(2, '0'); // Padding single digit days with zero
            
        //     return {
        //         ...item,
        //         date: `${year}-${month}-${day}` // Format as yyyy-mm-dd
        //     };
        // });

        let formattedList = formattedGridList(newGridList);
        let originalFormattedGridList = formattedGridList(originalGridList);
    
        const draft = [];
        const publish = [];
        const endOfDay = new Date();
        endOfDay.setHours(23, 57, 30, 0);
        const endOfDayTime = endOfDay.getTime();

        const now = Date.now();

        formattedList.forEach((schedule, index) => {
            if (index === 0) {
                const totalFutureDuration = schedule.scheduleItems.reduce((sum, item) => {
                    if (item.endAt <= now) {
                        return sum;
                    }

                    if (item.startAt < now && item.endAt > now) {
                        return sum + (item.endAt - now);
                    }

                    if (item.startAt >= now) {
                        return sum + (item.endAt - item.startAt);
                    }

                    return sum;
                }, 0);

                const requiredDuration = endOfDayTime - now;

                if (totalFutureDuration >= requiredDuration) {
                    publish.push(schedule?.date);
                } else {
                    draft.push(schedule?.date);
                }
            } else {
                const totalDuration = schedule.scheduleItems.reduce(
                    (sum, item) => sum + item.totalDuration,
                    0
                );

                if (totalDuration >= (24 * 60 * 60 * 1000) - 150000) {
                    publish.push(schedule?.date);
                } else {
                    draft.push(schedule?.date);
                }
            }
        });


        let draftData = originalFormattedGridList.filter(entry => 
            draft.some(data => data === entry.date)
        );
        let publishData = originalFormattedGridList.filter(entry => 
            publish.some(data => data === entry.date)
        );
        async function sendSequentially(payload) {
            // Helper function to send one payload
            async function sendPayload(data) {
                const response = await Schedule_update_weekly(data, locationState?.state?.channelId);
                if (response) {
                    
                } else {
                    toast.error(`Data upload failed for ${data?.draft[0]?.date? data?.draft[0]?.date : data?.publish[0]?.date}`, {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        autoClose: 3000
                    });
                    setLoaderStatus(false);
                }
            }

            // First send draft items one by one
            for (let i = 0; i < payload.draft.length; i++) {
                const singlePayload = {
                timeOffset: payload.timeOffset,
                draft: [payload.draft[i]], // ek hi object array me
                publish: [] // publish empty rahe
                };
                await sendPayload(singlePayload);
            }

            // Then send publish items one by one
            for (let i = 0; i < payload.publish.length; i++) {
                const singlePayload = {
                timeOffset: payload.timeOffset,
                draft: [], // draft empty rahe
                publish: [payload.publish[i]] // ek hi object array me
                };
                await sendPayload(singlePayload);
            }

            toast.success("Channel Updated successfully", {
                position: toast.POSITION.BOTTOM_RIGHT,
                autoClose: 3000
            });
            // today();
            const newStartDate = new Date(startDate);
            newStartDate.setDate(newStartDate.getDate());
            const start = newStartDate.toISOString().split("T")[0];

            const newEndDate = new Date(startDate);
            newEndDate.setDate(newEndDate.getDate() + 7);
            const end = newEndDate.toISOString().split("T")[0];
            fetchLinearData(start, end, 7);
            setLoaderStatus(false);
        }

        let payload = {
            timeOffset: gmtOffSetFunc(),
            draft: draftData,
            publish: publishData
        }
        sendSequentially(payload);

        // // const response = await Schedule_update(formattedGridList, locationState?.state?.channelId);
        // const response = await Schedule_update_weekly(payload, locationState?.state?.channelId);
        
        // if (response) {
        //     toast.success("Channel Updated successfully", {
        //         position: toast.POSITION.BOTTOM_RIGHT,
        //         autoClose: 3000
        //     });
        //     // today();
        //     const newStartDate = new Date(startDate);
        //     newStartDate.setDate(newStartDate.getDate());
        //     const start = newStartDate.toISOString().split("T")[0];

        //     const newEndDate = new Date(startDate);
        //     newEndDate.setDate(newEndDate.getDate() + 7);
        //     const end = newEndDate.toISOString().split("T")[0];
        //     fetchLinearData(start, end, 7);
        //     setLoaderStatus(false);
        // } else {
        //     toast.error("Channel Update failed", {
        //         position: toast.POSITION.BOTTOM_RIGHT,
        //         autoClose: 3000
        //     });
        //     setLoaderStatus(false);
        // }
    }

};

export const confirmSaveAndUpdate = async (
    btnType,
    setLoaderStatus,
    gridList,
    saveLinerPrograms,
    locationState,
    toast,
    today,
    confirmPublishWithDate,
) => {
    if (btnType === "Save") {
        setLoaderStatus(true);
        let newGridList = gridList.slice(1);
        // newGridList = newGridList.map(item => {
        //     const localDate = new Date(item.date); // Convert to Date object
        //     localDate.setHours(0, 0, 0, 0); // Set to local 12 AM
        
        //     const utcDate = new Date(Date.UTC(
        //         localDate.getFullYear(),
        //         localDate.getMonth(),
        //         localDate.getDate(),
        //         0, 0, 0, 0
        //     )); // Convert to UTC 12 AM
        
        //     return { ...item, date: utcDate.getTime() };
        // });

        // for (let i = 1; i < newGridList.length; i++) {
        //     let currentObj = newGridList[i];
        //     let previousObj = newGridList[i - 1];
        
        //     if (currentObj.scheduleItems.length > 0) {
        //         let remainingItems = [];
        
        //         currentObj.scheduleItems.forEach(schedule => {
        //             if (schedule.startAt < currentObj.date) {
        //                 previousObj.scheduleItems.push(schedule);
        //             } else {
        //                 remainingItems.push(schedule);
        //             }
        //         });
        
        //         currentObj.scheduleItems = remainingItems;
        //     }
        // }
        
        const formattedGridList = newGridList.map(item => {
            const dateObj = new Date(item.date);
            const year = dateObj.getFullYear();
            const month = (dateObj.getMonth() + 1).toString().padStart(2, '0'); // Adding 1 to month as it's 0-indexed
            const day = dateObj.getDate().toString().padStart(2, '0'); // Padding single digit days with zero
            
            return {
                ...item,
                date: `${year}-${month}-${day}` // Format as yyyy-mm-dd
            };
        });

        const filteredGridList = formattedGridList.filter((item) => item?.published === false);            
        const response = await saveLinerPrograms(locationState?.state?.channelId, filteredGridList);
        if (response) {
            toast.success("Programs successfully saved.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                autoClose: 3000
            });
            today();
            setLoaderStatus(false);
        } else {
            toast.error("Failed to save programs.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                autoClose: 3000
            });
            setLoaderStatus(false);
        }
    } else if (btnType === "Save & Publish") {
        confirmPublishWithDate();
    }
}